import React from "react";
import styled from "styled-components";
const Container = styled.div`
  margin: 1rem 0;
  margin-top: 3.75rem;
  padding: 1rem 2rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  /* box-shadow: 0 4px 8px rgba(66, 153, 225, 0.08); */
  height: fit-content;
  padding-bottom: 2rem;
  max-width: 30rem;
`;

const Title = styled.p`
  margin-bottom: 0.75rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #2b4c7e;
  letter-spacing: -0.03em;
  line-height: 1.3;
`;

const StepsList = styled.ol`
  margin: 0;
  padding-left: .875rem;
  counter-reset: steps;
`;

const StepItem = styled.li`
  color: #4a5568;
  margin-bottom: 0.5rem;
  line-height: 1.8;
  font-size: 1rem;
  font-weight: 500;
  font-style: italic;

  &:last-child {
    margin-bottom: 0;
  }

  &::marker {
    color: #3b82f6;
    font-weight: 600;
  }
`;

const LeaveInstructions = () => {
  const steps = [
    "Click the date in the calendar to apply leave start date",
    "Pop-up Leave application form to fill",
    `For half-day leave, click "Partial" box it shows 0.5 to 1.00 day`,
  ];

  return (
    <Container>
      <Title>How "Apply Leave" Works</Title>
      <StepsList>
        {steps.map((step, index) => (
          <StepItem key={index}>{step}</StepItem>
        ))}
      </StepsList>
    </Container>
  );
};

export default LeaveInstructions;
